import * as yup from "yup";
import React from "react";
import { ServiceRequestCommentDto } from "../../services/dto";
import Drawer from "../../assets/vfx/drawer/drawer";
import Form from "../../assets/vfx/form/form";
import { Constants } from "../../assets/utils/lib/constants";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../assets/utils/lib";

interface ServiceRequestNotesFormProps {
    data: ServiceRequestCommentDto | undefined;
    show: boolean;
    onHide: () => void;
    onSave: (values: ServiceRequestCommentDto) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
    comment: yup.string().required("Notes is required"),
});

export const ServiceRequestNotesForm = (props: ServiceRequestNotesFormProps) => {
    
    let title: string =  "Add Notes";
    const onSubmit = (data: ServiceRequestCommentDto) => {
        data.requestId = props.data?.requestId ?? Constants.emptyGuid;
        return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
    };

    return (
        <Drawer.Form
            className="w-30"
            show={props.show}
            backdrop={true}
            placement="end"
            scroll={true}
            onHide={props.onHide}
            title={title}
            initialValues={{ Comment: "" }}
            validationSchema={validationSchema}
            on_Submit={onSubmit}
        >

            <Form.TextArea
                name="comment"
                rows={3}
                label="Notes"
                isLoading={false}
            />

        </Drawer.Form>
    );
}

